import { render, staticRenderFns } from "./BranchSelectorDialog.vue?vue&type=template&id=8b6de9f8"
import script from "./BranchSelectorDialog.vue?vue&type=script&lang=js"
export * from "./BranchSelectorDialog.vue?vue&type=script&lang=js"
import style0 from "./BranchSelectorDialog.vue?vue&type=style&index=0&id=8b6de9f8&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports